module.exports = __webpack_public_path__ + "static/media/brake-fluid-exchange.93312488.svg";